import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import Loading from "../Layout/Loading";
import EntryFormContent from "./EntryFormContent";
import { addNewEntry } from "../../actions/VisitAction";

const AddNewEntry = ({ closeModal: parentCloseModal }) => {
  const modalRef = useRef(null);
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split("T")[0],
    doctorName: "",
    callNotes: "",
    productDiscussed: "",
  });
  const [loading, setLoading] = useState(false);

  // Check if the screen is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); //FIXME:
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  const closeModal = () => {
    setIsOpen(false);
    setTimeout(() => {
      parentCloseModal();
    }, 400);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (
      !formData.doctorName ||
      !formData.callNotes ||
      !formData.productDiscussed
    ) {
      toast.error("Please fill all required fields.");
      return;
    }

    setLoading(true);
    try {
      const response = await addNewEntry(formData);
      if (response.success) {
        toast.success("Successfully added");
        closeModal();
      } else {
        toast.error("Error occurred");
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <AnimatePresence>
        {isOpen &&
          (isMobile ? (
            // Mobile dialog (centered, no animation)
            <div
              ref={modalRef}
              className="bg-white w-[80%] max-w-md rounded-lg max-h-[80vh] overflow-y-auto px-6 shadow-lg"
            >
              {loading ? (
                <Loading />
              ) : (
                <>
                  {/* <button
                    onClick={closeModal}
                    className="absolute top-20 right-4 bg-white"
                  >
                    <X className="w-7 h-7 text-gray-500 hover:text-gray-800" />
                  </button> */}
                  <EntryFormContent
                    formData={formData}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    handleCancel={parentCloseModal}
                  />
                </>
              )}
            </div>
          ) : (
            // Desktop slide-in panel
            <motion.div
              ref={modalRef}
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "tween", duration: 0.4 }}
              className="bg-white w-[60%] h-full px-6 absolute right-0 top-0 shadow-lg max-w-[800px]"
            >
              {loading ? (
                <Loading />
              ) : (
                <>
                  <button
                    onClick={closeModal}
                    className="absolute top-0 -left-12 bg-gray-200 rounded-md p-1 shadow-md"
                  >
                    <X className="w-7 h-7 text-gray-500 hover:text-gray-800" />
                  </button>
                  <div className="pt-4">
                    <EntryFormContent
                      formData={formData}
                      handleChange={handleChange}
                      handleSubmit={handleSubmit}
                    />
                  </div>
                </>
              )}
            </motion.div>
          ))}
      </AnimatePresence>
    </div>
  );
};

export default AddNewEntry;
